module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BBREVIATIONS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BOC")])])]), _vm._v(" "), _c('td', {
    staticClass: "w70"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Constitution of the Presbyterian Church (USA), "), _c('a', {
    attrs: {
      "href": "#/010_Part01#pt-1"
    }
  }, [_vm._v("Part I")]), _vm._v(", "), _c('em', [_vm._v("Book of Confessions")]), _vm._v(". Louisville: Office of the General Assembly, 2016.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CD")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl Barth, "), _c('em', [_vm._v("Church Dogmatics")]), _vm._v(". Edited by G. W. Bromiley, T. F. Torrance, et al. 14 vols. Edinburgh: T&T Clark, 1936–1969.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CF")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Friedrich Schleiermacher, "), _c('em', [_vm._v("The Christian Faith")]), _vm._v(". Edited by H. R. Mackintosh and J. S. Stewart. Philadelphia: Fortress, 1976.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dogmatics")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Emil Brunner, "), _c('em', [_vm._v("Dogmatics")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("The Christian Doctrine of God")]), _vm._v(". Vol. 2, "), _c('em', [_vm._v("The Christian Doctrine of Creation and Redemption")]), _vm._v(". Vol. 3, "), _c('em', [_vm._v("The Christian Doctrine of the Church, Faith, and the Consummation")]), _vm._v(". Translated by Olive Wyon and David Cairns. London: Lutterworth, 1952.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ETP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James M. Gustafson, "), _c('em', [_vm._v("Ethics from a Theocentric Perspective")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("Theology and Ethics")]), _vm._v(". Vol. 2, "), _c('em', [_vm._v("Ethics and Theology")]), _vm._v(". Chicago: University of Chicago Press, 1981, 1984.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ICR")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Calvin, "), _c('em', [_vm._v("Institutes of the Christian Religion")]), _vm._v(". Edited by John T. McNeill. Translated by Ford Lewis Battles. Louisville: Westminster, 1960.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IFM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gordon D. Kaufman, "), _c('em', [_vm._v("In Face of Mystery: A Constructive Theology")]), _vm._v(". Cambridge, MA: Harvard University Press, 1993.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("LW")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Luther’s Works")]), _vm._v(". Edited by Jaroslav Pelikan et al. American Edition. St. Louis: Concordia, 1958–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NDM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Reinhold Niebuhr, "), _c('em', [_vm._v("The Nature and Destiny of Man")]), _vm._v(". Vol. 1, "), _c('em', [_vm._v("Human Nature")]), _vm._v(". Vol. 2, "), _c('em', [_vm._v("Human Destiny")]), _vm._v(". Louisville: Westminster John Knox, 1996.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ST")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Thomas Aquinas, "), _c('em', [_vm._v("Summa Theologiae")]), _vm._v(". Blackfriars Edition. New York: McGraw-Hill, 1964–1981.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Works of Saint Augustine: A Translation for the 21st Century")]), _vm._v(". John E. Rotelle, OSA, director. Hyde Park, NY: New City, 1997–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WJE")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Works of Jonathan Edwards")]), _vm._v(". General Editors, Perry Miller, John E. Smith, and Harry S. Stout. 26 vols. New Haven: Yale University Press, 1957–2008.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-055f6836","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbrevation.vue
// module id = 78
// module chunks = 0